import { Button, Form, Input, Modal, Select } from "antd";

import { selectFormOptionsNoFormatting } from "../../../utils/helper";

const CreateEditCourseSectionModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleCreateEdit = () => {},
  isEdit = false,
  setIsEdit = () => {},
  setInitialValues = () => {},
  initialValues = {}
}) => {
  const [form] = Form.useForm();
  return (
    <Modal
      title="Create/Edit Section"
      centered
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
        setIsEdit(false);
        setInitialValues({});
      }}
      onCancel={() => {
        setIsModalOpen(false);
        setIsEdit(false);
        setInitialValues({});
      }}
    >
      <Form
        form={form}
        initialValues={isEdit ? initialValues : {}}
        name="new_course_section_form"
        onFinish={handleCreateEdit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter a name!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input />
        </Form.Item>
        <Form.Item
          name="displayOrder"
          label="Display Order"
          rules={[
            {
              required: true,
              pattern: /\d+/,
              message: "Please enter a valid number!"
            }
          ]}
        >
          <Input placeholder="Enter a relative number" />
        </Form.Item>
        <Form.Item
          name="category"
          label="Category"
          rules={[
            {
              required: true,
              message: "Please select the section category"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["NORMAL", "SPECIAL"])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit ? "Edit" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditCourseSectionModal;
